import * as React from "react"
import { cn } from "@/lib/utils"

interface GradientTextProps extends React.ComponentProps<"span"> {
  children: React.ReactNode
  underline?: boolean
}

export function GradientText({ children, underline = false, className, ...props }: GradientTextProps) {
  return (
    <span 
      className={cn(
        "gradient-text",
        underline && "gradient-underline relative inline-block",
        className
      )} 
      {...props}
    >
      {children}
    </span>
  )
}
